export default class MatriculasProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }
    create(params) {
        return this.axios.post(this.url + '/matriculas', params);
    }

    cambiarParalelo(params) {
        return this.axios.post(this.url + '/matriculas/cambiarParalelo', params);
    }

    deleteMatricula(params) {
        return this.axios.post(this.url + '/matriculas/deleteMatricula', params);
    }

    getListaMatriculas() {
        return this.axios.get(this.url + `/matriculas/lista`);
    }

    getListaMatriculaByNota(curso, paralelo) {
        return this.axios.get(this.url + `/matriculas/listaNotas?curso=${curso}&paralelo=${paralelo}`);
    }

    getSecuencia() {
        return this.axios.get(this.url + `/matriculas/secuencia`);
    }

    get(id) {
        return this.axios.get(this.url + `/matriculas/${id}`);
    }
    getReportes(id) {
        return this.axios.get(this.url + `/matriculas/reportes/${id}`);
    }

    //====================RESPALDOS =====================================
    getRespaldo(id) {
        return this.axios.get(this.url + `/respaldos/${id}`);
    }

    getRespaldoCambio(id) {
        return this.axios.get(this.url + `/respaldos/cambio/${id}`);
    }

    //====================NOTAS =====================================
    createNotas(id, params) {
        return this.axios.put(this.url + `/notas/${id}`, params);
    }
     
    supletorios(id, params) {
        return this.axios.put(this.url + `/notas/supletorios/${id}`, params);
    }

    createNotasCualitativo(id, params) {
        return this.axios.put(this.url + `/notas/cualitativo/${id}`, params);
    }

    createNotasInicial(id, params) {
        return this.axios.put(this.url + `/notas/iniciales/${id}`, params);
    }
    createNotasReajuste(id, params) {
        return this.axios.put(this.url + `/notas/ajustar/${id}`, params);
    }
     //====================REPORTES =====================================

     getListaNomina() {
        return this.axios.get(this.url + `/matriculas/nomina`);
    }

    //====================ESTUDIANTES =====================================

    getMyMatricula(id) {
        return this.axios.get(this.url + `/matriculas/mynota/${id}`);
    }

    //====================REPORTES =====================================
   
    promocion(params) {
        return this.axios.post(this.url + '/reportes', params);
    }
    promocionPdf(params) {
        return this.axios.post(this.url + '/reportes/promocionPdf', params);
    }
    matricula(params) {
        return this.axios.post(this.url + '/reportes/matricula', params);
    }
    matriculaPdf(params) {
        return this.axios.post(this.url + '/reportes/matriculaPdf', params);
    }
    libretas(params) {
        return this.axios.post(this.url + '/reportes/libretas/', params);
    }
    juntas(params) {
        return this.axios.post(this.url + '/reportes/juntas/', params);
    }
    juntasIndividual(params) {
        return this.axios.post(this.url + '/reportes/juntasIndividual/', params);
    }
    juntasFinal(params) {
        return this.axios.post(this.url + '/reportes/juntasFinal/', params);
    }
    informe(params) {
        return this.axios.post(this.url + '/reportes/informe/', params);
    }
    parcial(params) {
        return this.axios.post(this.url + '/reportes/parcial/', params);
    }
    quimestral(params) {
        return this.axios.post(this.url + '/reportes/quimestral/', params);
    }
    anual(params) {
        return this.axios.post(this.url + '/reportes/anual/', params);
    }
    final(params) {
        return this.axios.post(this.url + '/reportes/final/', params);
    }
    nomina() {
        return this.axios.get(this.url + `/reportes/nomina`);
    }
    nominaDocentes() {
        return this.axios.get(this.url + `/reportes/nominaDocentes`);
    }
    ambitos(params) {
        return this.axios.post(this.url + '/reportes/ambitos/', params);
    }
    destrezas(params) {
        return this.axios.post(this.url + '/reportes/destrezas/', params);
    }
}

